import React from 'react';
import './FlagCarousel.css';

const flags = [
  { id: 1, name: 'Belgium', src: 'https://flagcdn.com/w320/be.png', alt: 'Belgium Flag' },
  { id: 2, name: 'Burkina Faso', src: 'https://flagcdn.com/w320/bf.png', alt: 'Burkina Faso Flag' },
  { id: 3, name: 'Cameroon', src: 'https://flagcdn.com/w320/cm.png', alt: 'Cameroon Flag' },
  { id: 4, name: 'Canada', src: 'https://flagcdn.com/w320/ca.png', alt: 'Canada Flag' },
  { id: 5, name: 'Ivory Coast', src: 'https://flagcdn.com/w320/ci.png', alt: 'Ivory Coast Flag' },
  { id: 6, name: 'Egypt', src: 'https://flagcdn.com/w320/eg.png', alt: 'Egypt Flag' },
  { id: 7, name: 'France', src: 'https://flagcdn.com/w320/fr.png', alt: 'France Flag' },
  { id: 8, name: 'Gabon', src: 'https://flagcdn.com/w320/ga.png', alt: 'Gabon Flag' },
  { id: 9, name: 'Germany', src: 'https://flagcdn.com/w320/de.png', alt: 'Germany Flag' },
  { id: 10, name: 'Netherlands', src: 'https://flagcdn.com/w320/nl.png', alt: 'Netherlands Flag' },
  { id: 11, name: 'Italy', src: 'https://flagcdn.com/w320/it.png', alt: 'Italy Flag' },
  { id: 12, name: 'Niger', src: 'https://flagcdn.com/w320/ne.png', alt: 'Niger Flag' },
  { id: 13, name: 'Portugal', src: 'https://flagcdn.com/w320/pt.png', alt: 'Portugal Flag' },
  { id: 14, name: 'Senegal', src: 'https://flagcdn.com/w320/sn.png', alt: 'Senegal Flag' },
  { id: 15, name: 'Spain', src: 'https://flagcdn.com/w320/es.png', alt: 'Spain Flag' },
  { id: 16, name: 'Switzerland', src: 'https://flagcdn.com/w320/ch.png', alt: 'Switzerland Flag' },
  { id: 17, name: 'Syria', src: 'https://flagcdn.com/w320/sy.png', alt: 'Syria Flag' },
  { id: 18, name: 'Tunisia', src: 'https://flagcdn.com/w320/tn.png', alt: 'Tunisia Flag' },
  { id: 19, name: 'United Kingdom', src: 'https://flagcdn.com/w320/gb.png', alt: 'United Kingdom Flag' },
  { id: 20, name: 'United States', src: 'https://flagcdn.com/w320/us.png', alt: 'United States Flag' },
  { id: 21, name: 'Mali', src: 'https://flagcdn.com/w320/ml.png', alt: 'Mali Flag' },
  { id: 22, name: 'Guinea', src: 'https://flagcdn.com/w320/gn.png', alt: 'Guinea Flag' },
  { id: 23, name: 'Central African Republic', src: 'https://flagcdn.com/w320/cf.png', alt: 'Central African Republic Flag' },
  { id: 24, name: 'Morocco', src: 'https://flagcdn.com/w320/ma.png', alt: 'Morocco Flag' }
];

function FlagCarousel() {
  return (
    <div className="flag-carousel">
      <div className="flag-carousel-container">
        <div className="flag-carousel-track">
          {/* First set of flags */}
          {flags.map((flag) => (
            <div key={`first-${flag.id}`} className="flag-slide">
              <img src={flag.src} alt={flag.alt} />
              {/* <span className="flag-name">{flag.name}</span> */}
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {flags.map((flag) => (
            <div key={`second-${flag.id}`} className="flag-slide">
              <img src={flag.src} alt={flag.alt} />
              {/* <span className="flag-name">{flag.name}</span> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FlagCarousel;
